(function () {
  var config = document.querySelector('script[data-third-party-deferred]');
  if (!config) return;

  var queue = [];
  var started = false;
  var interactions = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];

  function start() {
    if (started) return;
    started = true;
    interactions.forEach(function (name) {
      window.removeEventListener(name, start);
    });
    while (queue.length) queue.shift()();
  }

  function defer(fn) {
    if (started) fn();
    else queue.push(fn);
  }

  function inject(src, attributes) {
    var element = document.createElement('script');
    element.async = true;
    element.src = src;
    Object.keys(attributes || {}).forEach(function (name) {
      element.setAttribute(name, attributes[name]);
    });
    document.head.appendChild(element);
  }

  interactions.forEach(function (name) {
    window.addEventListener(name, start, { passive: true, once: true });
  });

  // These widgets sit below the fold or open on demand, so they wait for an idle
  // main thread instead of competing with the first fold. The interaction
  // listeners above pull them in early if the visitor gets there first.
  function scheduleIdle() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 4000 });
    else setTimeout(start, 2500);
  }

  if (document.readyState === 'complete') scheduleIdle();
  else window.addEventListener('load', scheduleIdle);

  var enchantId = config.getAttribute('data-enchant-id');
  if (enchantId) {
    defer(function () {
      inject('https://platform.enchant.com', { 'data-enchant-messenger-id': enchantId });
    });
  }

  defer(function () {
    if (typeof window.affirmDeferredLoad === 'function') window.affirmDeferredLoad();
  });
})();
